import { useAuth } from 'modules/auth/hooks/useAuth';
import { useIsSMDown } from 'uiKit/Theme/useTheme';

export const useHasAddToProjectItem = () => {
  const { isLoggedIn } = useAuth();
  const isMobile = useIsSMDown();

  return isMobile && isLoggedIn;
};
